var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"modal-overlay"},[_c('section',{staticClass:"modal"},[_c('header',[_c('h2',[_vm._t("title")],2)]),_c('div',[_vm._t("default")],2),_c('footer',[_vm._t("footer")],2)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }